module.exports = __webpack_public_path__ + "static/media/10.5c8d9a79.jpg";